<app-navbar [title]="data?.number">
	<button class="btn btn-warning me-4" (click)="deleteAsk()"><i class="fas fa-archive"></i> Archiwizuj</button>
	<button class="btn btn-primary me-4" (click)="showAdd()"><i class="fas fa-user-plus"></i> Dodaj właściciela</button>
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>
<!--
<app-navbar [title]="pageTitle">
	<button class="btn btn-warning me-3" *ngIf="pageFunction=='edit' && !editable" (click)="deleteAsk()">Usuń</button>
	<button class="btn btn-primary me-3" *ngIf="(pageFunction=='edit' && editable) || pageFunction=='add'" (click)="submit()">Zapisz</button>
	<button class="btn btn-primary me-3" *ngIf="pageFunction=='edit' && !editable" (click)="editUnlock()" >Edycja</button>
	<a class="btn btn-danger" routerLink="../">
		<i class="fas fa-chevron-left"></i> Powrót
	</a>
</app-navbar>
-->
<app-bank-account-owners
	[(account)]="data"
	[ownersTypes]="ownersTypes"
	[users]="users"
	[drivers]="drivers"
	[vehicles]="vehicles"
	[departments]="departments"
></app-bank-account-owners>
